import axios from 'axios'

import { PRODUCTINFO as ENDPOINT } from '../common/endpoints'
import { success, error } from '../main/toast-notifications'
import { t } from '../main/i18n'
import { createLightbox, /*updateContent*/ } from '../main/lightbox'

const targetClass = '.j-lightbox__info'
const targetBtn = document.querySelector('.j-open--info')
const lightbox = document.querySelector(targetClass)
const infoForm = lightbox.querySelector('form')
let lightboxInstance

const bindEvents = (infoForm) => {
	infoForm.addEventListener('submit', getToken)
}

const removeEvents = (infoForm) => {
	infoForm.removeEventListener('submit', getToken)
}

const getToken = (evt) => {
	evt.preventDefault()
	grecaptcha.ready(function() {
		grecaptcha.execute('6Ldtk0gfAAAAACPWMoSiKjmoEZ68JbjcdCT9Vqo-', {action: 'submit'}).then(function(token) {

			const tokenField = document.querySelector('.g-recaptcha-token')
			tokenField.value = token
			handleSubmit(evt)

		})
	})
}

const handleSubmit = async (e) => {
	e.preventDefault()
	const tokenField = document.querySelector('.g-recaptcha-token')
	const { name, lastname, text, copy, email } = e.target
	const Product = window.motostorm?.product || {}
	const Lang = window.motostorm?.lang

	try {
		const res = await axios.post(ENDPOINT, {
			data: {
				...Product,
				Lang,
				name: name.value,
				lastName: lastname.value,
				text: text.value,
				copy: +copy.checked,
				email: email.value,
				grToken: tokenField.value
			},
		})

		// update form content (remove this line if the success notification is enough)
		//updateContent(res.data, lightboxInstance, bindEvents, removeEvents)
		removeEvents(infoForm)
		// and/or automatically close the lightbox
		lightboxInstance.close()
		// display toast notification (remove this line if you prefer to display the response from the service)
		success(t('info-success'))		
	} catch (err) {
		console.error(`${err.name}: ${err.message}`)
		error(t('info-error'))
	}
}

const init = () => {
	// bind events before the lightbox is removed from DOM
	if (targetBtn && lightbox) {
		bindEvents(infoForm)
		lightboxInstance = createLightbox(targetBtn, targetClass)
	}
}

init()